import type { MercureTopic } from './types';

export class MercureTopics {
    private topics: Partial<Record<MercureTopic, number>>;

    constructor() {
        this.topics = {};
    }

    addTopic(topic: string) {
        this.topics[topic] = (this.topics[topic] || 0) + 1;
    }

    removeTopic(topic: string) {
        if (this.topics[topic] === undefined) {
            return;
        }

        this.topics[topic] = (this.topics[topic] || 0) - 1;

        if ((this.topics[topic] || 0) < 1) {
            delete this.topics[topic];
        }
    }

    clean() {
        this.topics = {};
    }

    getTopics(): string[] {
        return Object.keys(this.topics);
    }

    hasTopic(topic: string): boolean {
        const count = this.topics[topic];

        return !!count;
    }
}
